import { Animated, Col } from "@commonlibs";
import clsx from "clsx";
import { ReactNode } from "react";
import Logo from "../../display/Logo/Logo";
import { BackgroundLayoutWithLogoRoot } from "./BackgroundLayoutWithLogo.styles";

export interface BackgroundLayoutWithLogoProps {
    children?: ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default function BackgroundLayoutWithLogo({ children, className, ...rest }: BackgroundLayoutWithLogoProps): JSX.Element {
    return (
        <BackgroundLayoutWithLogoRoot className={clsx("background-layout-with-logo", className)} {...rest}>
            <Col flex={1} alignItems="center" justifyContent="center" css={{ minHeight: "15rem" }}>
                <Animated.Fade duration={{ enter: 850, exit: 200 }}>
                    <Logo color="white" link={false} size={"lg"} />
                </Animated.Fade>
            </Col>
            {children}
        </BackgroundLayoutWithLogoRoot>
    );
}
